import React from "react";
import { component_tool } from "@/tool";
import { WizTableForm } from "@/containers/common";
import { mergeColumns } from "../../utils";

const { WizDropdown, WizMenu, WizIcon } = component_tool;

const path = WizTableForm.Config.path(this, { apiParams: { state: 2 } });
const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } });
const organization = WizTableForm.Config.organization(this, {
  apiParams: { state: 1 },
});

//配置项
const componentName = "pathReport";

function columns() {
  const columns = [
    {
      title: "路径名称",
      name: "pathId",
      searchItem: {
        ...path,
        diy: WizTableForm,
        selectType: "radio",
        rules: [
          {
            required: true,
            message: "请选择路径名称",
          },
        ],
      },
    },
    {
      title: "路径名称",
      name: "pathName",
      tableItem: {},
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员身份证",
      name: "idCard",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    {
      title: "dp账号状态",
      name: "dpAvtiveStatusCn",
      tableItem: {},
    },
    {
      title: "dp人脸识别结果",
      name: "dpAuthenRecordCn",
      tableItem: {},
    },
    {
      title: "账号状态",
      name: "accountState",
      tableItem: {},
      searchItem: {
        type: "select",
      },
      dict: [
        { code: 1, codeName: "激活" },
        { code: 0, codeName: "禁用" },
      ],
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategory",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: [],
      },
      searchItem: {
        type: 'treeselect',
        allowClear: true,
        treeCheckable: true,
        treeCheckStrictly: true
      },
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        type: 'popover',
      },
    }
  ];

  return mergeColumns.call(this, columns, [{ dataIndex: 'accomplishType', event: this.handleAccomplishTypeClick, text: '查看' }]);
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ["export"],
          buttons: [
            {
              key: "export",
              custom: true,
              params: { icon: "export", children: "导出", type: "export" },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {},
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters };
                },
              },
            },
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          }
        },
        dataTableProps: {
          rowKey: (record, index) => index,
          bordered: true,
          isScroll: true,
          loading: false,
        },
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListStudentComplete`,
    payload: {
      key: `${componentName}@getPageListStudentComplete`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportStudentComplete`,
    payload: {
      key: `${componentName}@exportStudentComplete`,
      apiParams: {},
    },
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `organizationNodeCategory@getTypeNodeList`,
      apiParams: {},
    },
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
